exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".top-nav .account-menu{width:248px;height:auto;box-shadow:0 0 10px 0 rgba(61,61,61,.2);background-color:#fff;position:absolute;top:48px;right:0;border-radius:4px}.top-nav .account-menu .arrow-up{width:0;height:0;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid #fff;position:absolute;top:-12px;left:112px}.top-nav .account-menu__header{width:100%;height:52px;border-bottom:1px solid #ccc;padding:16px;font-size:18px;font-family:fontSemiBold,sans-serif}.top-nav .account-menu__body{padding:16px}.top-nav .account-menu__list{width:100%;height:auto;font-size:16px;font-family:fontSemiBold,sans-serif;padding:0;margin-bottom:16px}.top-nav .account-menu__list__item{width:100%;height:24px;display:block;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/account-menu/index.scss
// module id = 878
// module chunks = 0